import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'sp-advance-payment',
  templateUrl: './advance-payment.component.html',
  styleUrls: ['./advance-payment.component.scss']
})
export class AdvancePaymentComponent implements OnInit {
  public listData: any;
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    private mdDialogRef: MatDialogRef<AdvancePaymentComponent>
  ) {
    this.listData = data;
  }

  ngOnInit(): void {
    console.log('listData', this.listData);
  }

  fullfillOrder() {
    this.mdDialogRef.close(true);
  }

  onCancel() {
    this.mdDialogRef.close(false);
  }
}
